import { ref } from "vue";

export function useToggle(initialState = false) {
  const state = ref(initialState);

  const toggle = () => {
    state.value = !state.value;
  };

  const open = () => {
    state.value = true;
  };

  const close = () => {
    state.value = false;
  };

  return {
    state,
    toggle,
    open,
    close,
  };
}
